import { ButtonHTMLAttributes, FC } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

export interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'yellow'
    | 'transparent'
    | 'blue'
    | 'transparentBlue'
    | 'opacityBlue'
    | 'solidBlue'
    | 'grey'
    | 'black'
    | 'dark'
    | 'dangerOutlined'
    | 'danger'
    | 'white'
  className?: string
  borderRadius?: 'sm' | 'nr' | 'lr' | 'md'
  loading?: boolean
}

export const Button: FC<Props> = (props) => {
  const {
    children,
    className = '',
    variant = 'yellow',
    borderRadius = 'nr',
    loading = false,
    disabled,
    onClick,
    ...buttonProps
  } = props

  return (
    <button
      className={clsx(s[variant], s[borderRadius], s.button, className, {
        [s.loading]: loading,
      })}
      disabled={disabled}
      onClick={loading ? undefined : onClick}
      {...buttonProps}
    >
      {loading ? (
        <div className={s.spinner}>
          <div className={s.spinnerInner} />
        </div>
      ) : (
        children
      )}
    </button>
  )
}
